import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Cabservicenearmemumbai() {



  const cardData = {
    keyword: " Cab Service Near Me Mumbai ",


"headingDescription": "Royal Route Cab offers fast and reliable cab service near you in Mumbai, ensuring comfortable, safe, and hassle-free travel anytime you need. Whether you require an instant local ride, airport transfer, corporate travel, or outstation journey, our professional drivers and well-maintained vehicles provide a smooth experience across all areas of Mumbai. With quick pickups, transparent pricing, and 24/7 availability, booking a cab near you has never been easier. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and dedicated customer support, Royal Route Cab is your trusted choice for nearby cab services in Mumbai.",

"topPlaces": [
  {
    "title": "Lonavala",
    "description": "Lonavala is one of the closest and most popular tourist destinations near Mumbai, known for its lush green hills, waterfalls, and scenic viewpoints. Attractions such as Bhushi Dam, Tiger’s Leap, and Rajmachi Point make it an ideal weekend getaway."
  },
  {
    "title": "Khandala",
    "description": "Khandala is a beautiful hill station located near Mumbai, famous for its mist-covered valleys, winding roads, and panoramic mountain views. It is a favorite destination for nature lovers and road trip enthusiasts."
  },
  {
    "title": "Matheran",
    "description": "Matheran is a charming eco-friendly hill station where vehicles are not allowed, offering a peaceful environment, toy train rides, forest trails, and stunning viewpoints. It is one of the most relaxing destinations near Mumbai."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a popular coastal town near Mumbai known for its clean beaches, sea forts, and relaxing atmosphere. Visitors enjoy beach activities, seafood, and attractions such as Kolaba Fort and Alibaug Beach."
  },
  {
    "title": "Karnala Bird Sanctuary",
    "description": "Karnala Bird Sanctuary is a nature lover’s paradise located near Mumbai, offering trekking trails, rich biodiversity, and the historic Karnala Fort. It is a great destination for wildlife enthusiasts and photographers."
  },
  {
    "title": "Igatpuri",
    "description": "Igatpuri is a scenic hill station surrounded by the Sahyadri mountains, famous for waterfalls, lush greenery, and peaceful surroundings. It is especially popular during the monsoon season."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake is a picturesque destination near Mumbai known for lakeside camping, beautiful sunsets, and breathtaking mountain views. It is a favorite spot for weekend picnics and overnight camping experiences."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic trekking destination near Mumbai offering stunning views of the Sahyadri ranges. It attracts adventure enthusiasts, trekkers, and history lovers throughout the year."
  },
  {
    "title": "Imagicaa Theme Park",
    "description": "Imagicaa Theme Park is one of India's leading entertainment destinations near Mumbai, featuring thrilling rides, water attractions, and family-friendly activities suitable for all age groups."
  },
  {
    "title": "Kaas Plateau",
    "description": "Kaas Plateau, often called the Valley of Flowers of Maharashtra, is famous for its seasonal blooms and breathtaking natural beauty. It is a popular destination for nature lovers and photography enthusiasts."
  }
],






services: [
  {
    name: "Cab Service Near Me Mumbai",
    description: "Cab service near me Mumbai offers quick and convenient transportation options available in your nearby location. This service ensures fast pickup and easy booking for daily travel, office commutes, and emergency rides. Professional drivers and clean vehicles provide comfort and safety. It guarantees a smooth and hassle-free journey."
  },
  {
    name: "Taxi Near Me Mumbai",
    description: "Taxi near me Mumbai provides instant access to nearby taxis for quick travel needs. This service is ideal for short trips and urgent rides. Vehicles are well-maintained and driven by experienced chauffeurs. It ensures reliable and comfortable travel anytime."
  },
  {
    name: "Nearby Cab Service Mumbai",
    description: "Nearby cab service Mumbai helps you find available cabs in your area for immediate travel. This service is perfect for daily commuting and local trips. Quick booking and fast response ensure convenience. It guarantees a seamless travel experience."
  },
  {
    name: "Nearest Taxi Service Mumbai",
    description: "Nearest taxi service Mumbai connects you with the closest available taxis for fast pickup. This service is ideal for urgent travel needs and quick city rides. Professional drivers ensure safe and timely journeys. It ensures efficient transportation."
  },
  {
    name: "Local Cab Near Me Mumbai",
    description: "Local cab near me Mumbai offers reliable travel within the city with nearby vehicles. This service is perfect for office commutes, shopping trips, and daily errands. Flexible booking options enhance convenience. It ensures smooth city travel."
  },
  {
    name: "24 Hours Cab Near Me Mumbai",
    description: "24 hours cab near me Mumbai ensures round-the-clock availability of nearby cabs. This service is ideal for late-night travel, early morning rides, and emergencies. Quick booking and reliable drivers ensure timely service. It guarantees convenience anytime."
  },
  {
    name: "Cheap Cab Near Me Mumbai",
    description: "Cheap cab near me Mumbai provides budget-friendly transportation options available in your area. This service is ideal for cost-conscious travelers. Affordable fares and transparent pricing ensure no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Taxi Near Me Mumbai",
    description: "Best taxi near me Mumbai connects you with top-rated cab services in your location. This service ensures quality vehicles, professional drivers, and excellent customer service. Suitable for all travel needs. It guarantees a premium experience."
  },
  {
    name: "Airport Cab Near Me Mumbai",
    description: "Airport cab near me Mumbai provides nearby cabs for quick airport pickup and drop. This service ensures timely travel to domestic and international terminals. Professional drivers and comfortable vehicles enhance the journey. It guarantees a stress-free airport transfer."
  },
  {
    name: "Outstation Cab Near Me Mumbai",
    description: "Outstation cab near me Mumbai offers nearby vehicles for long-distance travel to other cities. This service is ideal for weekend trips, business travel, and family vacations. Well-maintained cars ensure highway safety. It guarantees a smooth journey."
  },
  {
    name: "Instant Cab Near Me Mumbai",
    description: "Instant cab near me Mumbai provides quick booking and immediate cab availability in your location. This service is perfect for urgent travel needs. Fast response and professional drivers ensure timely service. It guarantees convenience and speed."
  },
  {
    name: "Online Cab Near Me Mumbai",
    description: "Online cab near me Mumbai allows users to book nearby cabs easily through online platforms. This service offers quick booking, secure payments, and instant confirmation. Suitable for daily and long-distance travel. It ensures a hassle-free booking experience."
  },
  {
    name: "Private Taxi Near Me Mumbai",
    description: "Private taxi near me Mumbai offers personalized travel with exclusive vehicle usage. This service allows flexible routes and timing based on customer needs. Ideal for families and business travelers. It ensures a comfortable and private journey."
  },
  {
    name: "Reliable Cab Near Me Mumbai",
    description: "Reliable cab near me Mumbai ensures dependable transportation with trusted drivers and well-maintained vehicles. This service focuses on punctuality and safety. Suitable for all travel needs. It guarantees a smooth and stress-free experience."
  }
],

tableData: [
  ["Cab Service Near Me Mumbai", "Taxi Near Me Mumbai"],
  ["Nearby Cab Service Mumbai", "Nearest Taxi Service Mumbai"],
  ["Local Cab Near Me Mumbai", "24 Hours Cab Near Me Mumbai"],
  ["Cheap Cab Near Me Mumbai", "Best Taxi Near Me Mumbai"],
  ["Airport Cab Near Me Mumbai", "Outstation Cab Near Me Mumbai"],
  ["Instant Cab Near Me Mumbai", "Online Cab Near Me Mumbai"],
  ["Private Taxi Near Me Mumbai", "Reliable Cab Near Me Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Cab Service Near You in Mumbai",
    WhyChoosedescription: "Royal Route Cabs provides fast and reliable cab service near you in Mumbai for local travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Quick Pickup & Nearby Availability",
    WhyChoosedescription: "Get quick cab availability near your location with fast pickup service across all areas of Mumbai."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained, polite, and experienced in Mumbai routes, ensuring safe and smooth travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs offers clear pricing with no hidden costs, ensuring complete fare transparency."
  },
  {
    WhyChooseheading: "24/7 Cab Service Near You",
    WhyChoosedescription: "Our cab service near you in Mumbai operates 24/7, making it easy to book rides anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a comfortable ride."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "We provide nearby cab services for daily travel, airport pickup-drop, and outstation journeys from Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers based on your needs."
  }
]

};

const faqData = [
  { question: "How can I find cab service near me in Mumbai?", answer: "You can book a cab near you in Mumbai with Royal Route Cabs through phone or online booking." },
  { question: "Is cab service available near me 24 hours?", answer: "Yes, our cab service near you in Mumbai operates 24/7." },
  { question: "Do you provide instant cab booking?", answer: "Yes, we offer quick and instant cab booking with fast pickup." },
  { question: "Which areas in Mumbai do you cover?", answer: "We cover all areas including South Mumbai, Andheri, Borivali, Navi Mumbai, and Thane." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide airport cab service?", answer: "Yes, we offer Mumbai airport pickup and drop services." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from your exact location anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended during peak hours." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Joshi",
    feedback: "Finding a cab service near me in Mumbai with Royal Route Cabs was very easy. The response was quick and the ride experience was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Sharma",
    feedback: "Very reliable cab service near me in Mumbai. The driver arrived quickly, the car was clean, and the overall journey felt safe and hassle-free.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service Near Me Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/cab-service-near-me-mumbai.jpg", // replace if needed
  "description": "Find cab service near you in Mumbai with Royal Route Cabs. Book instant local, airport, and outstation taxis 24x7 with reliable drivers. Choose from sedan, SUV, Innova, and luxury cars for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499", // starting local fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/cab-service-near-me-mumbai"
  }
};








  return (
    <div>
<Helmet>
  <title>Cab Service Near Me Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Looking for cab service near me in Mumbai? Book instant taxi with Royal Route Cabs. 24x7 local, airport & outstation cabs with safe, reliable & affordable rides."
  />

  <meta
    name="keywords"
    content="cab service near me mumbai, taxi near me mumbai, nearby cab service mumbai, nearest taxi service mumbai, local cab near me mumbai, 24 hours cab near me mumbai, cheap cab near me mumbai, best taxi near me mumbai, airport cab near me mumbai, outstation cab near me mumbai, instant cab near me mumbai, online cab near me mumbai, private taxi near me mumbai, reliable cab near me mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabservicenearmemumbai;